import { useEffect, useState, createContext, useContext } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import ServicesPage from '@/pages/ServicesPage';
import BrandsPage from '@/pages/BrandsPage';
import ContactPage from '@/pages/ContactPage';
import Preloader from '@/components/Preloader';
import WhatsAppWidget from '@/components/WhatsAppWidget';
import SocialFollowWidget from '@/components/SocialFollowWidget';

// Create context for modal state
export const ModalContext = createContext();

// ScrollToTop component to handle scroll behavior on route change
function ScrollToTop() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Show preloader on route change
    setLoading(true);
    
    // Scroll to top instantly (preloader provides the smooth transition effect)
    window.scrollTo(0, 0);
    
    // Hide preloader after short delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return <Preloader loading={loading} />;
}

// App Routes component to access context
function AppRoutes({ onOpenModal }) {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/brands" element={<BrandsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <WhatsAppWidget onOpenModal={onOpenModal} />
      <SocialFollowWidget />
    </>
  );
}

function App() {
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    // Initial loading time
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Handle modal trigger from WhatsApp widget
  const handleOpenModal = () => {
    // Dispatch custom event to trigger modal on current page
    window.dispatchEvent(new CustomEvent('openQuoteModal'));
  };

  return (
    <>
      <Preloader loading={initialLoading} />
      <div className="App">
        <BrowserRouter>
          <AppRoutes onOpenModal={handleOpenModal} />
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;